

















































































































// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed, reactive } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ExportationViewerPage from '@/components/exportation/ExportationViewerPage.vue';
import ExportationFrameHeader from '@/components/exportation/frames/ExportationFrameHeader.vue';
import ExportationFrameComments from '@/components/exportation/frames/ExportationFrameComments.vue';
//
import ChartEvolutionRehabSide from '@/components/charts/evolution/rehab/ChartEvolutionRehabSide.vue';
import ChartEvolutionRehabGlobal from '@/components/charts/evolution/rehab/ChartEvolutionRehabGlobal.vue';
// Import helpers ----------------------------------------------------------------------------------
import { getUnit, EValueTypeUnit } from '@/helpers/helped-chart-functions.helper';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ExportationFrameJumpingCMJEvolution',
  components: {
    ExportationFrameHeader,
    ExportationViewerPage,
    ExportationFrameComments,
    //
    ChartEvolutionRehabSide,
    ChartEvolutionRehabGlobal
  },
  props: {
    analyses: {
      type: Object,
      required: true
    },
    advancedMode: {
      type: Boolean,
      required: true
    },
    pageTotal: {
      type: Number,
      required: true,
      default: 0
    },
    pdfData: {
      type: Object,
      required: true
    },
    headerInformations: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const aggregates = computed(() => properties.analyses.data.aggregates);
    const manifest = computed(() => properties.analyses.analysisManifests);

    const unit = reactive({
      centerofmass: getUnit(EValueTypeUnit.CenterOfMass)
    });

    return {
      aggregates,
      manifest,
      unit
    };
  }
});
